import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {ExternalCompanyEmployeeService} from '@shared/services/external-company-employee.service';
import {TranslationService} from '@shared/services/translation.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Store} from '@ngxs/store';
import {ActivatedRoute, Router} from '@angular/router';
import {ExternalLoginService} from '@shared/services/external-login.service';
import {LoginExternalInvitation, LoginExternalOpen, RefreshLogin} from '@shared/store/auth/auth.actions';
import {AuthState} from '@shared/store/auth/auth.state';
import {SaveSettings, SetSettings} from '@frontend/store/settings/settings.actions';
import {SettingsState} from '@frontend/store/settings/settings.state';
import {SetLanguage} from '@shared/store/language/language.actions';
import {SetDefaultTheme, SetTheme} from '@shared/store/theme/theme.actions';
import {PreviousRouteService} from '@shared/services/previous-route.service';

@Component({
    selector: 'saf-external-open-login',
    templateUrl: './external-open-login.component.html',
    styleUrls: ['./external-open-login.component.scss'],
    standalone: false
})
export class ExternalOpenLoginComponent implements OnInit {
  formGroup: FormGroup;
  companyId: number;

  constructor(
    private externalLoginService: ExternalLoginService,
    private translationService: TranslationService,
    private router: Router,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
    private store: Store,
    private previousRouterService: PreviousRouteService
  ) {
  }

  ngOnInit(): void {
    // this.store.dispatch([ new SetTheme({active: true, class: 'theme-dark', default: true, name: 'dark'}), new SaveSettings() ]);
    this.companyId = +this.route.snapshot.paramMap.get('companyId');
    this.getJWT();

    this.store.subscribe(data => {
    });
  }

  buildForm() {
    this.formGroup = new FormGroup({
      externalEmployeeFirstName: new FormControl(''),
      externalEmployeeName: new FormControl(''),
      externalCompanyName: new FormControl(''),
      email: new FormControl(''),
      language: new FormControl(1),
      companyId: new FormControl(this.companyId),
    });
  }

  getJWT() {
    const params = {
      companyId: this.companyId
    };
    this.store.dispatch(new LoginExternalOpen(params)).subscribe(result => {
      // TODO Check why result not works
/*      if (result.userDetail.errorMessage) {
        this.snackBar.open(
          this.translationService.translate(this.getFailureReason(result.userDetail.errorMessage)),
          '',
          {duration: 5000}
        );
      }*/
    });
    this.externalLoginService.openLogin(this.companyId).subscribe(data => {
      this.buildForm();
      // this.router.navigate(['online/start'], { queryParams: { isExternalInvitation: true, planId: data.data[0].id } });
      // this.snackBar.open(
      //   this.translationService.translate(this.getFailureReason(data.failureReason)),
      //   '',
      //   {duration: 2000});
    });
  }

  getFailureReason(failureReason: string) {
    switch (failureReason) {
      case 'MissingCompanyId':
        return 'MissingCompanyId';
      case 'OpenLoginDisabled':
        return 'OpenLoginDisabled';
      case 'NoOpenLoginUser':
        return 'NoOpenLoginUser';
      case 'NoOpenLoginCategory':
        return 'NoOpenLoginCategory';
      default:
        return failureReason;
    }
  }

  onSubmit() {
    const params = {
      // externalEmployeeId: this.externalEmployeeId,
      // companyId: 104,
      // securityCode: this.securityCode
    };
    // this.store.dispatch(new LoginExternalInvitation(params));

    const payload = {
      ...this.formGroup.value,
      languageId: this.formGroup.value.language?.id,
      language: this.formGroup.value.language
    };


    if (this.formGroup.value.language !== 1) {
      this.store.dispatch(new SetLanguage(this.formGroup.value.language));
    }

    if (this.formGroup.valid) {
      this.externalLoginService.openLoginExternalCompanyAndEmployee(payload).subscribe(data => {
        if (data?.success === false) {
          this.snackBar.open(this.translationService.translate(data.failureReason));
        } else {
          this.startFullscreen();
          this.previousRouterService.setManualPreviousUrl(this.router.url);
          this.router.navigate(
            ['online/start'],
            {
              queryParams:
                {
                  isExternalInvitation: true, planId: data.data[0].id,
                  externalEmployeeId: data.data[0].externalEmployeeId
                }
            });
        }

      });
    }

  }

  startFullscreen() {
    const elem = document.documentElement; // oder ein bestimmtes Element

    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if ((elem as any).webkitRequestFullscreen) { /* Safari */
      (elem as any).webkitRequestFullscreen();
    } else if ((elem as any).msRequestFullscreen) { /* IE11 */
      (elem as any).msRequestFullscreen();
    }
  }


  changeLanguage(language) {
    const user = this.store.selectSnapshot(AuthState.user);

    // if (this.formGroup.valid) {
    //   this.store.dispatch([
    //     new SetSettings(this.store.selectSnapshot(SettingsState.settingsForm).model),
    //     new SaveSettings(),
    //   ]);

    if (language) {
      // this.store.dispatch([ new SetLanguage(language), new SaveSettings() ]);
    }

    // }
    // const language = this.formGroup.get('language').value;
    // this.userDetailService.update(user.id, {user: {
    //     languageId: language['id']
    //   }})
    //   .pipe()
    //   .subscribe((result) => {
    //     this.store.dispatch(new RefreshLogin());
    //   });
  }
}
